// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.additionalProperties = false;
EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "accountType",
        "baseName": "accountType",
        "type": "AccountType"
    },
    {
        "name": "accountStatus",
        "baseName": "accountStatus",
        "type": "AccountStatus"
    },
    {
        "name": "assignedUser",
        "baseName": "assignedUser",
        "type": "number"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel>"
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountRelationModel>"
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountRelationModel>"
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountRelationModel>"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountAddressUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountPhoneUpsearchModel>"
    },
    {
        "name": "documents",
        "baseName": "documents",
        "type": "Array<EnterpriseCoordinatorCaseDocumentRelationshipModel>"
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": "Array<number>"
    },
    {
        "name": "tasks",
        "baseName": "tasks",
        "type": "Array<number>"
    },
    {
        "name": "voicemailOptInStatus",
        "baseName": "voicemailOptInStatus",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel>"
    },
    {
        "name": "contacts",
        "baseName": "contacts",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel>"
    },
    {
        "name": "contactPreferences",
        "baseName": "contactPreferences",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel>"
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel>"
    },
    {
        "name": "expireExistingAccountRelationships",
        "baseName": "expireExistingAccountRelationships",
        "type": "boolean"
    },
    {
        "name": "assignmentOfBenefitFlag",
        "baseName": "assignmentOfBenefitFlag",
        "type": "boolean"
    },
    {
        "name": "allowAutoReenroll",
        "baseName": "allowAutoReenroll",
        "type": "boolean"
    },
];
//# sourceMappingURL=enterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.js.map